import { NewVendor, Vendor } from "../models/Vendor";
import { host, getRequest, patchRequest, postRequest, deleteRequest } from "./apiService";

export async function getVendors() {
	return getRequest<Vendor[]>(`${host}/api/vendor`);
}
export async function updateVendor(vendor: Vendor) {
	return patchRequest<void>(
		`${host}/api/vendor/${vendor.id}`, vendor
	);
}
export async function addVendor(newVendor: NewVendor) {
	return postRequest<Vendor | undefined>(
		`${host}/api/vendor`, newVendor
	);
}
export async function deleteVendor(id: string) {
	return deleteRequest(`${host}/api/vendor/${id}`);
}